import ENV from '@root/src/javascripts/getEnv'
import { ApolloLink } from 'apollo-link'
import { createHttpLink } from 'apollo-link-http'
import { onError } from 'apollo-link-error'
import store from '@root/src/javascripts/store'
import PubSub from '@helper/PubSub'
import i18n from '@root/src/javascripts/i18n'
import { log as logToSentry } from '@helper/sentry'
import { localizedRoute } from '@helper/localizedRouting'
import { config } from '@root/src/javascripts/config'
import router from '@root/src/javascripts/router'
import createUploadLink from 'apollo-upload-client/createUploadLink.mjs'

const handleError = (data) => { // eslint-disable-line consistent-return
  let errorNumber
  if (!data) {
    return
  }

  if (data.statusCode >= 400) {
    errorNumber = (data.result && data.result.errors) ? data.result.errors[0].code : null

    if ([2, 8].includes(errorNumber)) {
      logToSentry(new Error(data.result.errors[0].message), data, 'verbose')
    }
  }

  if (data.statusCode === 400) {
    PubSub.publish('hide-loader')

    if (errorNumber === 8) {
      store.commit('SET_DECLINEDREASON', data.result.errors[0])
      return
    }

    if ([3, 4, 5, 6].includes(errorNumber)) {
      router.push(localizedRoute('Maintenance'))
      return
    }
    const error = config.errors.find((e) => e.code === errorNumber)

    if (error) {
      PubSub.publish('show-popup', {
        text: i18n.t(error.msg),
        isError: true,
      })
    }
  }

  if (data.statusCode >= 500) {
    logToSentry(new Error(data))
    PubSub.publish('show-popup', {
      text: i18n.t('errors.graphqlQueryBase'),
      isError: true,
    })
  }
}

const handleGraphQLErrors = (errors) => {
  handleError({
    statusCode: 400,
    result: { errors },
  })
}

const getLanguageFromLocale = (locale) => locale.split('-')[0]

export function getApolloLink() { // eslint-disable-line import/prefer-default-export
  console.info(`Connecting to "${ENV.apiUrl}"`)

  const httpOptions = {
    uri: ENV.apiUrl,
    transportBatching: true,
  }

  // see https://dev.to/marvinrabe/file-upload-with-vue-apollo-client-and-graphql-5emb
  const httpLink = ApolloLink.split(
    (operation) => operation.getContext().hasUpload,
    createUploadLink(httpOptions),
    createHttpLink(httpOptions),
  )

  const middlewareLink = new ApolloLink((operation, forward) => {
    operation.setContext({
      headers: {
        authorization: `Bearer ${store.getters.getAuthenticationToken}`,
        'Accept-Language': getLanguageFromLocale(i18n.locale || 'de'),
      },
    })
    return forward(operation)
  })

  const errorLink = onError(({ graphQLErrors, networkError }) => {
    // FIXME: https://jira.sumcumo.net/browse/DEXMFV-915
    if (graphQLErrors) {
      handleGraphQLErrors(graphQLErrors)
    } else {
      handleError(networkError)
    }
  })

  const link = ApolloLink.from([
    middlewareLink,
    errorLink,
    httpLink,
  ])
  return link
}
